import { create } from 'zustand';

export const useResponseStore = create((set) => ({
    response: {
        preguntas: [],
        tratamiento_datos: 'no',
        servicio: ''
    },

    setOtherData: (data) => set(state => ({
        ...state,
        response: { ...state.response, ...data }
    })),

    setService: (data) => set(state => ({
        ...state,
        response: { ...state.response, servicio: data }
    })),

    setDataTreatment: (data) => set(state => ({
        ...state,
        response: { ...state.response, tratamiento_datos: data }
    })),

    setQuestions: (data) => set(state => ({
        ...state,
        response: { ...state.response, preguntas: [...state.response.preguntas, data] }
    })),

    clearStore: () => set({}, true)
}));